import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// Ohne onUpdate-Handler installierte sich ein neuer Service Worker zwar, blieb
// aber im "waiting"-Zustand — die App lief nach einem Deploy weiter mit dem ALTEN
// Bundle, bis der User alle Tabs schloss. Deshalb kamen Fixes nicht an.
let refreshing = false;
if ("serviceWorker" in navigator) {
  // NUR reloaden, wenn vorher schon ein Service Worker das Ruder hatte —
  // dann ist der Reload das, wofür er gedacht ist: raus aus dem alten Bundle.
  //
  // Beim ALLERERSTEN Besuch übernimmt der frisch installierte Worker per
  // clientsClaim() ebenfalls die Seite und löste denselben Reload aus. Wer
  // gerade einen QR-Code gescannt hatte, flog dadurch aus dem Beitritt zurück
  // auf die Startseite — beim zweiten Mal (Worker schon installiert) ging es.
  // Genau das war der "erst beim zweiten Mal klappt's"-Effekt.
  const hatteVorherEinenWorker = !!navigator.serviceWorker.controller;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    // Guard gegen Reload-Schleifen
    if (refreshing || !hatteVorherEinenWorker) return;
    refreshing = true;
    window.location.reload();
  });
}

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (registration.waiting) {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
    }
  },
});

reportWebVitals();
